import type { Session } from '@supabase/supabase-js'
import { command } from 'ccstate'
import { apiRegistry } from '../../common/infra/apiRegistry'
import { authClient } from '../../common/infra/authClient'
import './apiImpl'

export const setupPrototype = command(({ get }) => {
  if (process.env.VITE_USE_PROTOTYPE !== 'true') {
    return
  }
  authClient.useFake = {
    access_token: 'fake_access_token',
    user: {
      email: 'prototype@user.com'
    }
  } as Session
  apiRegistry.useDirectRoute = get
})